import React, {createContext, useContext, useState, useEffect} from 'react';
import './spinner-overlay.scss';

const SpinnerOverlayContext = createContext({
  showSpinner: () => {},
  hideSpinner: () => {}
});

export const useSpinnerOverlay = () => {
  return useContext(SpinnerOverlayContext);
};

export const SpinnerOverlayProvider = ({children}) => {

  const [isVisible, setIsVisible] = useState(false);

  const showSpinner = () => setIsVisible(true);
  const hideSpinner = () => setIsVisible(false);

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  return (
      <SpinnerOverlayContext.Provider value={{
        showSpinner,
        hideSpinner
      }}>
        {children}
        {isVisible && <SpinnerOverlay/>}
      </SpinnerOverlayContext.Provider>
  );
};

const SpinnerOverlay = () => {
  return (<div className="spinner-overlay">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Lädt...</span>
    </div>
  </div>);
};
